import { chain } from "lodash";
const getAllSubTypeNames = (type, defaultComponentTypes) => {
    const childComponentTypeNames = [];
    const childTypes = defaultComponentTypes.filter((componentType) => componentType.parent === type);
    childTypes.forEach((childType) => {
        childComponentTypeNames.push(childType.type);
        childComponentTypeNames.push(...getAllSubTypeNames(childType.type, defaultComponentTypes));
    });
    return childComponentTypeNames;
};
export const isComponentType = (typeNameToTest, typeNamesToCompareTo, defaultComponentTypes) => {
    if (typeNameToTest === null || typeNameToTest === undefined) {
        return false;
    }
    if (typeof typeNamesToCompareTo === "string" &&
        typeNameToTest === typeNamesToCompareTo) {
        return true;
    }
    const normalizedTypeNamesToCompareTo = Array.isArray(typeNamesToCompareTo)
        ? typeNamesToCompareTo
        : [typeNamesToCompareTo];
    const typesToCheck = chain(normalizedTypeNamesToCompareTo)
        .map((typeNameToCompareTo) => getAllSubTypeNames(typeNameToCompareTo, defaultComponentTypes))
        .push(normalizedTypeNamesToCompareTo)
        .flatten()
        .uniq()
        .value();
    return typesToCheck.includes(typeNameToTest);
};
